import { NgModule } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { NavigationComponent } from './navigation/navigation.component';
import { NavigationService } from './navigation.service';
import { HelpComponent } from './components/help/help.component';
import { PopoverModule } from '../shared/components/popover/popover.module';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
import { NavigationItemComponent } from './components/navigation-item/navigation-item.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationMenuComponent } from './components/navigation-menu/navigation-menu.component';
import { HeaderPopupComponent } from './components/header-popup/header-popup.component';
import { HeaderProfilePopupComponent } from './components/header-profile-popup/header-profile-popup.component';
import { ImageCroppingComponent } from '@app/shared/components/image-cropping/image-cropping.component';
import { ButtonsModule } from '@app/shared/components/buttons/buttons.module';
import { MatIconModule } from '@angular/material/icon';
import { MenuNavigationItemComponent } from './components/menu-navigation-item/menu-navigation-item.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialsModule } from '@app/shared/modules/material.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatSliderModule } from '@angular/material/slider';
import { HeaderNotificationsComponent } from '@app/main/components/header-notifications/header-notifications.component';
import { DirectiveModule } from '@app/shared/directives/directive.module';
import { HeaderFeedbackComponent } from './components/header-feedback/header-feedback.component';
import { FormFieldsModule } from '@app/shared/components/form-fields/form-fields.module';
import { DropdownsModule } from '@app/shared/components/dropdowns/dropdowns.module';
import { CmUploadFlowModule } from '@app/shared/components/cm-upload-flow/cm-upload-flow.module';
import { NotificationItemComponent } from './components/header-notifications/components/notification-item/notification-item.component';
import { NavigationSectionMenuComponent } from './components/navigation-section-menu/navigation-section-menu.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TitleCasePipe } from '@angular/common';

@NgModule({
  declarations: [
    HeaderComponent,
    NavigationComponent,
    HelpComponent,
    HeaderSearchComponent,
    NavigationItemComponent,
    NavigationMenuComponent,
    NavigationSectionMenuComponent,
    HeaderNotificationsComponent,
    NotificationItemComponent,
    HeaderPopupComponent,
    HeaderProfilePopupComponent,
    ImageCroppingComponent,
    MenuNavigationItemComponent,
    HeaderFeedbackComponent,
  ],
  imports: [
    SharedModule,
    MaterialsModule,
    PopoverModule,
    MatSidenavModule,
    ButtonsModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule,
    MatChipsModule,
    DirectiveModule,
    FormFieldsModule,
    DropdownsModule,
    CmUploadFlowModule,
    ImageCropperModule,
    MatSliderModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    HeaderComponent,
    NavigationComponent,
    HelpComponent,
    HeaderNotificationsComponent,
    NotificationItemComponent,
    HeaderFeedbackComponent,
  ],
  providers: [
    NavigationService,
    HeaderComponent,
    TitleCasePipe,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class MainModule {}
